export class Faq {

  constructor() {
    this.add_class_by_scroll();
  }

  add_class_by_scroll() {
    const nav = document.querySelectorAll('.page-FaqNav_Li');
    const target_arr = [];
    const offsetTop = window.pageYOffset;
    const buffer = window.innerWidth <= 900 ? 250 : 160;
    let timeoutId;

    for (let i = 0; i < nav.length; i++) {
      const elem = document.getElementById('section_' + i);

      if (elem) {
        target_arr[i] = offsetTop + elem.getBoundingClientRect().top;
      }
    }

    function remove_current($node) {
      for (let i = 0; i < $node.length; i++) {
        $node[i].classList.remove('current');
      }
    }

    function set_nav(currentY) {
      if (target_arr[6] && currentY >= target_arr[6] - buffer) {
        // console.log('6');
        remove_current(nav);
        nav[6].classList.add('current');
      } else if (target_arr[4] && currentY >= target_arr[5] - buffer) {
        // console.log('5');
        remove_current(nav);
        nav[5].classList.add('current');
      } else if (target_arr[4] && currentY >= target_arr[4] - buffer) {
        // console.log('4');
        remove_current(nav);
        nav[4].classList.add('current');
      } else if (target_arr[3] && currentY >= target_arr[3] - buffer) {
        // console.log('3');
        remove_current(nav);
        nav[3].classList.add('current');
      } else if (target_arr[2] && currentY >= target_arr[2] - buffer) {
        // console.log('2');
        remove_current(nav);
        nav[2].classList.add('current');
      } else if (target_arr[1] && currentY >= target_arr[1] - buffer) {
        // console.log('1');
        remove_current(nav);
        nav[1].classList.add('current');
      } else {
        // console.log('0');
        remove_current(nav);
        nav[0].classList.add('current');
      }
    }

    set_nav(window.pageYOffset);

    window.addEventListener("scroll", function () {
      // setTimeout()がセットされていたら無視
      if (timeoutId) return;

      timeoutId = setTimeout(function () {
        timeoutId = 0;

        set_nav(window.pageYOffset);

      }, 250);
    });
  }

}